(function($) {
    $(document).ready(function() {

        function isItANumber(val, button, error) {

            if ( isNaN( val ) ) {
                // console.log("not a number", val);

                button.prop('disabled', true);

                error.text('It needs to be a valid amount of money');
                $('#sos-donate-slider .handle-num').fadeOut();
                error.fadeIn();

            } else {

                button.prop('disabled', false);
                $('#sos-donate-slider .handle-num').fadeIn();
                error.fadeOut();
                condition = true;
                return true;

            }
        }

        function isInRange(val, button, error) {
            var max = 100;
            var min = 1;

            if (val >= min) { 

                button.prop('disabled', false);
                $('#sos-donate-slider .handle-num').fadeIn();
                error.fadeOut();

            } else if (val === '') {

                // nothing to validate
                button.prop('disabled', true);

            } else if ( val < 0) {

                button.prop('disabled', true);

                error.text('sorry, you can\'t donate less than nothing');
                error.fadeIn();

                return false;
                
            } else {

                button.prop('disabled', true);
                error.text('sorry, you can\'t donate nothing');
                error.fadeIn();

                return false;

            }

        }

        window.validate = function (val, button, error) {
            condition = false;
            isItANumber(val, button, error);
            if (condition) {
                isInRange(val, button, error);
            }
        };

        // $('#sos-submit').prop('disabled', true);

        var value = $('#sos-amount').val();
        var button =  $('.donate-submit');
        var error = $('#sos-form-error');

        window.validate(value, button, error);

    });
})(jQuery);
